import { Archive, Clock, Sparkles } from "lucide-react";
import { useActiveAiRuns } from "providers/background-tasks";
import { ProjectState } from "hooks/useProjects/useProjects.types";
import { isLimitedProject } from "../../ProjectsPage.constants";

const badgeClass =
  "flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[11px] font-medium backdrop-blur-sm";

/** Status chips shown over a project's poster. */
export const ProjectBadges = ({ project }: { project: ProjectState }) => {
  const activeAiRuns = useActiveAiRuns();
  const hasAiRunning = Boolean(activeAiRuns[String(project.projectId)]);

  if (!project.archived && !project.isDemo && !isLimitedProject(project) && !hasAiRunning) {
    return null;
  }

  return (
    <span className="flex flex-wrap items-center justify-end gap-1.5">
      {project.archived && (
        <span className={`${badgeClass} border-border bg-card/85 text-muted-foreground`}>
          <Archive className="h-3 w-3" aria-hidden />
          Archived
        </span>
      )}
      {project.isDemo && (
        <span className={`${badgeClass} border-border bg-card/85 text-foreground/80`}>Sample</span>
      )}
      {isLimitedProject(project) && (
        <span className={`${badgeClass} border-border bg-card/85 text-muted-foreground`}>
          <Clock className="h-3 w-3" aria-hidden />
          Limited
        </span>
      )}
      {hasAiRunning && (
        <span className={`${badgeClass} border-primary/25 bg-card/85 text-primary`}>
          <Sparkles className="h-3 w-3 animate-pulse" aria-hidden />
          AI running
        </span>
      )}
    </span>
  );
};
